"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function BellIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M18.777,14.8a.676.676,0,0,1-.677-.678V10.052a6.1,6.1,0,0,0-4.575-5.908v-.7a1.525,1.525,0,1,0-3.05,0v.7A6.1,6.1,0,0,0,5.9,10.052v4.066a.678.678,0,0,1-.677.678,1.358,1.358,0,0,0-1.357,1.356V17.17a.339.339,0,0,0,.34.338H19.794a.341.341,0,0,0,.34-.338V16.152A1.358,1.358,0,0,0,18.777,14.8Z" }),
        react_1.default.createElement("path", { d: "M12,20.382a1.524,1.524,0,0,1-1.522-1.523h-1.7a3.223,3.223,0,0,0,6.446,0h-1.7A1.524,1.524,0,0,1,12,20.382Z" })));
}
exports.default = BellIcon;
